import { render } from "./ContactGroupForm.vue?vue&type=template&id=57d30d90"
import script from "./ContactGroupForm.vue?vue&type=script&lang=js"
export * from "./ContactGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__